module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0157.jpg?v=a8d8ba0a";